// @flow
import { createReducer } from 'actions';
import { LOAD_REPORTS, LOAD_SINGLE_REPORT } from 'actions/reports';
import { LOGOUT } from 'actions/auth';
import type {
  Report,
  LoadReportsAction,
  SingleReport,
  LoadSingleReportAction,
} from 'actions/reports';

type State = {
  all: Array<Report>,
  singles: { [reportId: string]: SingleReport },
};

const initialState: State = {
  all: [],
  singles: {},
};
export default createReducer(initialState, {
  [LOAD_REPORTS]: (state: State, action: LoadReportsAction) => {
    if (action.meta.done && !action.meta.error && action.payload) {
      return {
        ...state,
        all: [...action.payload],
      };
    }
    return state;
  },
  [LOAD_SINGLE_REPORT]: (state: State, action: LoadSingleReportAction) => {
    if (action.meta.done && !action.meta.error && action.payload) {
      return {
        ...state,
        singles: {
          ...state.singles,
          [action.payload.reportId]: action.payload,
        },
      };
    }
    return state;
  },

  [LOGOUT]: () => {
    return { ...initialState };
  },
});



// WEBPACK FOOTER //
// ./src/redux/reducers/reports.js